import React, { PropsWithChildren } from "react";
import { FilterProps } from "react-table";
import { LabsDropdown } from "./LabsDropdown";


interface ILabsFilterProps {
  filter: PropsWithChildren<FilterProps<any>>;
}

export const LabsFilter: React.FunctionComponent<ILabsFilterProps> = (props) => {
  return <span><LabsDropdown onChange={(ev, data) => {
    props.filter.setFilter(props.filter.column.id, data.value);
  }}></LabsDropdown></span>

};

